var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('survey-page',{attrs:{"questions":_vm.questions,"question-types":_vm.questionTypes,"page-title":("היי " + (this.householdName()) + ","),"pageSubTitle":'רצינו לדעת -',"set-answer":_vm.setAnswer,"buttonTitle":'המשך',"buttonAction":_vm.saveSurveyAnswers}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c723bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/survey/activation-survey/ActivationSurveyFirstPage.vue
// module id = null
// module chunks = 